module.exports = __webpack_public_path__ + "static/media/customer-pepsi.ad04d362.png";